<template>
  <vue-ellipse-progress
    :progress="progress"
    :color="color"
    :size="size"
    thickness="12%"
    empty-thickness="12%"
  >
    <slot />
  </vue-ellipse-progress>
</template>

<script>
    export default {
        props: {
            progress: {
                type: Number,
                required: true
            },
            color: {
                type: String,
                required: false,
                default: '#060181'
                
            },
            size: {
                type: Number,
                required: false,
                default: 128
            }
        }
    };
</script>

<style scoped></style>